



















import { Component, Vue } from "vue-property-decorator";
import { ICoupon } from "@/store/interfaces/coupon";
import CouponCard from "./CouponCard.vue";
import { mapGetters } from "vuex";

@Component({
  name: "TopCouponCardContainer",
  components: { CouponCard },
  computed: {
    ...mapGetters({
      getTopCoupons: "home/getTopCoupons",
      isLoading: "home/isLoading",
      lang: "app/lang"
    })
  }
})
export default class TopCouponCardContainer extends Vue {
  getTopCoupons: ICoupon[];
}
